export const changelogData = [
  {
    date: '18.11.2025',
    version: '1.0.0',
    changes: [
      { text: ['Welcome to Yoko Orbit'], type: 'Added' },
    ],
  },
];
